import { useCallback, useEffect, useState } from 'react';

import { countLabelStateChange } from 'lib/models/nfcCards';

/**
 * How many cards of a label blocking all of them would block, and unblocking all of them
 * would unblock, as the API counts them for the confirmation. Null while there is no label,
 * while they are read, or when they could not be read.
 *
 * @param label The label, matched exactly; none for no counts
 */
function useNfcLabelStateCounts(label: string | null) {
	const [counts, setCounts] = useState<{ label: string; block: number; unblock: number } | null>(null);

	const refetch = useCallback(async () => {
		setCounts(null);
		if (!label) return;

		try {
			const [block, unblock] = await Promise.all([
				countLabelStateChange(label, true),
				countLabelStateChange(label, false),
			]);
			setCounts({ label, block, unblock });
		} catch (error) {
			console.error(error);
		}
	}, [label]);

	useEffect(() => {
		refetch();
	}, [refetch]);

	// A count of another label, still on its way when the label changed, is never shown
	return { counts: counts?.label === label ? counts : null, refetch };
}

export default useNfcLabelStateCounts;
